import { useState, useEffect, useCallback } from 'react';
import { getStates, getCitiesByState } from '../services/api';

// Module-level cache: states/cities are static reference data, fetched once
// per session and shared across all hook instances (no invalidation/TTL).
let statesCache = null;
let statesPromise = null;
const citiesCache = new Map();

export default function useStatesCities() {
  const [states, setStates] = useState(statesCache || []);
  const [loading, setLoading] = useState(!statesCache);

  useEffect(() => {
    let active = true;
    if (statesCache) {
      setStates(statesCache);
      setLoading(false);
      return;
    }
    if (!statesPromise) {
      statesPromise = getStates()
        .then((res) => {
          statesCache = res.data || [];
          return statesCache;
        })
        .catch((err) => {
          statesPromise = null;
          throw err;
        });
    }
    statesPromise
      .then((list) => {
        if (active) setStates(list);
      })
      .catch(() => {})
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const getCitiesForState = useCallback(async (stateId) => {
    if (!stateId) return [];
    const key = String(stateId);
    if (citiesCache.has(key)) return citiesCache.get(key);
    const res = await getCitiesByState(stateId);
    const list = res.data || [];
    citiesCache.set(key, list);
    return list;
  }, []);

  return { states, getCitiesForState, loading };
}
